import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";
import hexToRGBA from "../../../hexToRGBA";

const toopltip = ({ palette, spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiTooltip"] => {
	const shadowColor = hexToRGBA(palette.black, 0.08);
	const spacing025 = spacing(0.25);
	const spacing05 = spacing(0.5);
	const spacing1 = spacing(1);
	const spacing2 = spacing(2);

	return {
		tooltip: {
			color: undefined,
			backgroundColor: palette.white,
			padding: `${spacing1} ${spacing2}`,
			boxShadow: `
				0px ${spacing2} ${spacing(4)} ${shadowColor},
				0px ${spacing1} ${spacing2} ${shadowColor},
				0px ${spacing05} ${spacing1} ${shadowColor},
				0px ${spacing025} ${spacing05} ${shadowColor},
				0px ${spacing(0.175)} ${spacing025} ${shadowColor};
			`,
		},
		arrow: {
			color: palette.white,
		},
	};
};

export default toopltip;
